import { useAxios } from "../useAxios"

export interface ITransformedPost {
    id: string;
    event_date: string;
    event_type: "new_post";
    blob: {
        post_content: string;
        post_image: string | null;
        post_document: string | null;
        post_video: string | null;
        post_poll: string | null;
        post_article: string | null;
        is_newsletter: boolean;
        num_likes: number;
        num_comments: number;
        num_shares: number;
        num_views: number;
        permalink: string;
        reacted: string | null;
        ugcPostId: string;
    };
    connectionId: string;
    total_engagements: number;
    engagement_rate: string;
    linked_in_user_person_id: string | null;
    time_ago_text: string;
    time_ago: string;
    post_type: "text" | "image" | "video" | "document" | "poll" | "article";
    post_sub_type: "original" | "reshare";
    post_tags: string[];
    reposted_post: ITransformedPost | null;
}

export interface IBulkPostsPayload {
    posts: ITransformedPost[];
    publicIdentifier?: string;
}

export interface IWorkspacePost {
    _id: string;
    workspace: string;
    profile: string;
    posts: {
        post: ITransformedPost;
        skipped: boolean;
        _id: string;
    };
    profileInfo: {
        _id: string;
        firstName: string;
        lastName: string;
        publicIdentifier: string;
        profilePicture: string;
        headline: string;
        autoTagsArray: any;
    };
    createdAt: string;
    updatedAt: string;
    profileInfoReposted: {
        _id: string;
        firstName: string;
        lastName: string;
        publicIdentifier: string;
        profilePicture: string;
        headline: string;
    };
    feeds?: { _id: string; name: string; dateAdded?: string; }[];
}

export interface IWorkspacePostsResponse {
    posts: IWorkspacePost[];
    pagination: {
        page: number;
        limit: number;
        total: number;
        totalPages: number;
    };
}

export const usePostsRequest = () => {
    const { sendRequest } = useAxios()

    const route = '/posts'

    //POST
    const createOrUpdateBulkPosts = (payload: IBulkPostsPayload, displayToast?: boolean) => {
        return sendRequest({
            slug: 'createOrUpdateBulkPosts',
            url: `${route}`,
            method: 'POST',
            payload,
            displayToast: displayToast ?? false
        })
    }

    //GET
    const getWorkspacePosts = (params?: { page?: number, limit?: number }) => {
        return sendRequest({
            slug: 'getWorkspacePosts',
            url: `${route}/workspace`,
            method: 'GET',
            params,
            displayToast: false
        })
    }

    //GET
    const getProfilesWithTrackedConnections = () => {
        return sendRequest({
            slug: 'getProfilesWithTrackedConnections',
            url: `${route}/tracked-connections`,
            method: 'GET',
            displayToast: false
        })
    }

    const updateConnectionPosts = (payload: any) => {
        return sendRequest({
            slug: 'updateConnectionPosts',
            url: `${route}/update-connection-posts`,
            method: 'POST',
            payload,
            displayToast: false
        })
    }

    const updateWeeklyGoal = (weeklyGoal: number) => {
        return sendRequest({
            slug: 'updateWeeklyGoal',
            url: `${route}/update-weekly-goal`,
            method: 'POST',
            payload: { weeklyGoal },
            displayToast: false,
            all: true
        })
    }

    return {
        createOrUpdateBulkPosts,
        getWorkspacePosts,
        getProfilesWithTrackedConnections,
        updateConnectionPosts,
        updateWeeklyGoal
    };
}
